import Api from "../../utils/config/api";
import { toastr } from "react-redux-toastr";
import {
  SET_DASHBOARD_SEGMENTS,
  SET_CUSTOMER_SEGMENTS,
  SET_SELECTED_SEGMENT,
  RESET_SELECTED_SEGMENT,
  RESET_AUDIENCE_REC_STATE,
} from "../types";

export const setRecommendedSegments = (isDashboard, data) => (dispatch) => {
  dispatch({
    type: isDashboard ? SET_DASHBOARD_SEGMENTS : SET_CUSTOMER_SEGMENTS,
    payload: data,
  });
};

export const fetchRecommendedAudience =
  (entityId, isDashboard) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v2/campaigns/${entityId}/audience-recommendation?threshold=${
          isDashboard ? "500" : "100"
        }`
      )
        .then((res) => {
          dispatch(setRecommendedSegments(isDashboard, res?.data?.payload));
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to fetch recommended audience."
          );
          dispatch(resetAudienceRecState());

          return reject(err);
        });
    });
  };

export const fetchRecommendedClusterById =
  (entityId, clusterId) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(`/v2/campaigns/${entityId}/audience-recommendation/${clusterId}`)
        .then((res) => {
          dispatch({ type: SET_SELECTED_SEGMENT, payload: res?.data?.payload });
          resolve(res?.data?.payload);
        })
        .catch((err) => {
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to fetch recommended campaign."
          );
          dispatch(resetSelectedSegment());

          return reject(err);
        });
    });
  };

export const setSelectedSegment = (segment) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_SEGMENT,
    payload: segment,
  });
};

export const resetSelectedSegment = () => (dispatch) => {
  dispatch({
    type: RESET_SELECTED_SEGMENT,
  });
};

export const fetchRecommendedClusterOverview =
  (entityId, clusterId, isExporting) => () => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v2/campaigns/${entityId}/audience-recommendation/${clusterId}/overview${
          isExporting ? "?attachment=true" : ""
        }`
      )
        .then((res) => resolve(isExporting ? res?.data : res?.data?.payload))
        .catch((err) => {
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to fetch overview of recommended campaigns."
          );

          return reject(err);
        });
    });
  };

export const resetAudienceRecState = () => (dispatch) => {
  dispatch({
    type: RESET_AUDIENCE_REC_STATE,
  });
};
